<template>
  <div class="yingxiao">
    <!-- 		<img src="../assets/z1.png" width="1200px"/>
		<img src="../assets/z2.png" width="1200px"/>
		<img src="../assets/z3.png" width="1200px"/>
		<img src="../assets/z4.png" width="1200px"/>
		<img src="../assets/z5.png" width="1200px"/> -->
    <img src="http://img.rbcdef.com/z1.png" width="1920px" />
    <img src="http://img.rbcdef.com/z2.png" width="1920px" />
    <img src="http://img.rbcdef.com/z3.png" width="1920px" />
    <img src="http://img.rbcdef.com/z4.png" width="1920px" />
    <img src="http://img.rbcdef.com/z5.png" width="1920px" />
    <!-- 		<div class="content">
			<div class="bg1">
				
			</div>
		</div> -->
    <!-- 页面上方 -->
    <!-- 输入框 -->
    <input
      class="inp topinp"
      type="text"
      @change="handleInpValue"
      v-model="value"
      placeholder="请输入您的手机号码..."
    />

    <!-- 领取按钮 -->

    <div class="receive topbtn" @click="handleClick">立即领取</div>

    <!-- 了解更多 -->
    <a href="">
      <div class="more topmore"></div>
    </a>

    <!-- 页面下方 -->
    <input
      class="inp bominp"
      type="text"
      @change="handleInpValue"
      v-model="value"
      placeholder="请输入您的手机号码..."
    />

    <!-- 领取按钮 -->

    <div class="receive bombtn" @click="handleClick">立即领取</div>

    <!-- 了解更多 -->
    <a href="">
      <div class="more bommore"></div>
    </a>


    <!-- 备案号 -->
    <div class="beianhao">
        <a href="https://beian.miit.gov.cn/">粤IPC备 2020092105号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "zsyYingXiao",
  data() {
    return {
      msg: "hello yingxiao",
      value: "",
    };
  },
  methods: {
    //输入框失焦
    handleInpValue() {
      if (
        !/^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/.test(this.value)
      ) {
        alert("手机号输入有误,请重新输入");
      }
    },
    // 点击领取
    handleClick() {
      if (this.value) {
        let telnum = localStorage.getItem("telnum");
        if (telnum !== this.value) {
          // 插入手机号接口地址
          // http://47.115.173.78:9080/yingxiaoyue
          // 参数:
          // phone
          // 方法:get.
          this.$axios
            .get("http://47.115.173.78:9080/yingxiaoyue", {
              params: { phone: this.value },
            })
            .then((res) => {
              console.log(res);
              // localStorage.setItem('telnum',this.value)
              if (res.data.result.code == 200) {
                localStorage.setItem("telnum", this.value);
                alert("名额领取成功");
              }
            });

          // .then(res=>{
          // 	console.log(res);
          // 	localStorage.setItem('telnum',this.value)
          // }).catch(err=>{
          // 	console.log(err);
          // })
        } else {
          alert("不可以重复申请喔");
        }
      } else {
        alert("手机号不能为空哦");
      }
    },
  },
};
</script>

<style>
.yingxiao {
  display: block;
  position: relative;
  text-align: center;
}
img {
  display: block;
  margin: 0 auto;
}

.inp {
  width: 980px;
  height: 68px;
  font-size: 22px;
  position: absolute;

  border: 0;
  outline: 0;
  border-radius: 10px;
  box-sizing: border-box;
  padding-left: 1em;
}

.receive {
  width: 280px;
  height: 72px;
  background-color: #ebeb7b;
  box-sizing: border-box;
  font-size: 30px;
  position: absolute;
  color: #320000;

  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.more {
  width: 154px;
  height: 52px;
  border: 2px solid #fff;
  border-radius: 10px;
  font-size: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  box-sizing: border-box;
  /* color: #fff; */
}
.topinp {
  top: 980px;
  left: 470px;
}
.topbtn {
  top: 1080px;
  left: 821px;
}
.topmore {
  top: 1098px;
  left: 1304px;
}

.bominp {
  left: 470px;
  bottom: 608px;
}
.bombtn {
  left: 820px;
  bottom: 502px;
}
.bommore {
  left: 1296px;
  bottom: 512px;
}

.beianhao{
    position: absolute;
    bottom: 35px;
    left: 706px;
    background-color: #c80101;
    width: 500px;
    margin: 0 auto;
}
a{
    text-decoration: none;
    font-size: 26px;
}
a:visited{
    color: #fff;
}
/* 	.bg1{
		width: 1200px;
	} */
</style>
